export default __webpack_public_path__ + "static/media/glenn-carstens-peters-RLw-UC03Gwc-unsplash.68e8756b.jpg";